export const profileContactInividualFieldConfig = {
  gender: {
    label: 'contacts.contacts.contact_individual.gender.label',
    options: [
      {
        text: 'global.contact_individual.gender.placeholder',
        value: null,
      },
      {
        text: 'global.contact_individual.man',
        value: 'M',
      },
      {
        text: 'global.contact_individual.woman',
        value: 'W',
      },
      {
        text: 'global.contact_individual.na',
        value: '-',
      },
    ],
    conditionalShow: {
      fieldPath: 'type',
      operator: '=',
      value: 'individual',
      actionIfHide: null,
    },
    wrapperAttributes: {
      class: {
        'inline-field col-md-2 pl-2': true,
      },
    },
  },
  birthdate: {
    label: 'contacts.contacts.contact_individual.birthdate.label',
  },
  nationality: {
    label: 'contacts.contacts.contact_individual.nationality.label',

    wrapperAttributes: {
      class: {
        'inline-field col-md-3 pr-2 pl-2': true,
      },
    },
    options: [
      {
        text: 'nationalities.placeholder',
        value: 'null',
      },
      {
        text: 'nationalities.ad',
        value: 'ad',
      },
      {
        text: 'nationalities.ae',
        value: 'ae',
      },
      {
        text: 'nationalities.af',
        value: 'af',
      },
      {
        text: 'nationalities.ag',
        value: 'ag',
      },
      {
        text: 'nationalities.ai',
        value: 'ai',
      },
      {
        text: 'nationalities.al',
        value: 'al',
      },
      {
        text: 'nationalities.am',
        value: 'am',
      },
      {
        text: 'nationalities.ao',
        value: 'ao',
      },
      {
        text: 'nationalities.aq',
        value: 'aq',
      },
      {
        text: 'nationalities.ar',
        value: 'ar',
      },
      {
        text: 'nationalities.as',
        value: 'as',
      },
      {
        text: 'nationalities.at',
        value: 'at',
      },
      {
        text: 'nationalities.au',
        value: 'au',
      },
      {
        text: 'nationalities.aw',
        value: 'aw',
      },
      {
        text: 'nationalities.ax',
        value: 'ax',
      },
      {
        text: 'nationalities.az',
        value: 'az',
      },
      {
        text: 'nationalities.ba',
        value: 'ba',
      },
      {
        text: 'nationalities.bb',
        value: 'bb',
      },
      {
        text: 'nationalities.bd',
        value: 'bd',
      },
      {
        text: 'nationalities.be',
        value: 'be',
      },
      {
        text: 'nationalities.bf',
        value: 'bf',
      },
      {
        text: 'nationalities.bg',
        value: 'bg',
      },
      {
        text: 'nationalities.bh',
        value: 'bh',
      },
      {
        text: 'nationalities.bi',
        value: 'bi',
      },
      {
        text: 'nationalities.bj',
        value: 'bj',
      },
      {
        text: 'nationalities.bl',
        value: 'bl',
      },
      {
        text: 'nationalities.bm',
        value: 'bm',
      },
      {
        text: 'nationalities.bn',
        value: 'bn',
      },
      {
        text: 'nationalities.bo',
        value: 'bo',
      },
      {
        text: 'nationalities.bq',
        value: 'bq',
      },
      {
        text: 'nationalities.br',
        value: 'br',
      },
      {
        text: 'nationalities.bs',
        value: 'bs',
      },
      {
        text: 'nationalities.bt',
        value: 'bt',
      },
      {
        text: 'nationalities.bv',
        value: 'bv',
      },
      {
        text: 'nationalities.bw',
        value: 'bw',
      },
      {
        text: 'nationalities.by',
        value: 'by',
      },
      {
        text: 'nationalities.bz',
        value: 'bz',
      },
      {
        text: 'nationalities.ca',
        value: 'ca',
      },
      {
        text: 'nationalities.cc',
        value: 'cc',
      },
      {
        text: 'nationalities.cd',
        value: 'cd',
      },
      {
        text: 'nationalities.cf',
        value: 'cf',
      },
      {
        text: 'nationalities.cg',
        value: 'cg',
      },
      {
        text: 'nationalities.ch',
        value: 'ch',
      },
      {
        text: 'nationalities.ci',
        value: 'ci',
      },
      {
        text: 'nationalities.ck',
        value: 'ck',
      },
      {
        text: 'nationalities.cl',
        value: 'cl',
      },
      {
        text: 'nationalities.cm',
        value: 'cm',
      },
      {
        text: 'nationalities.cn',
        value: 'cn',
      },
      {
        text: 'nationalities.co',
        value: 'co',
      },
      {
        text: 'nationalities.cr',
        value: 'cr',
      },
      {
        text: 'nationalities.cu',
        value: 'cu',
      },
      {
        text: 'nationalities.cv',
        value: 'cv',
      },
      {
        text: 'nationalities.cw',
        value: 'cw',
      },
      {
        text: 'nationalities.cx',
        value: 'cx',
      },
      {
        text: 'nationalities.cy',
        value: 'cy',
      },
      {
        text: 'nationalities.cz',
        value: 'cz',
      },
      {
        text: 'nationalities.de',
        value: 'de',
      },
      {
        text: 'nationalities.dj',
        value: 'dj',
      },
      {
        text: 'nationalities.dk',
        value: 'dk',
      },
      {
        text: 'nationalities.dm',
        value: 'dm',
      },
      {
        text: 'nationalities.do',
        value: 'do',
      },
      {
        text: 'nationalities.dz',
        value: 'dz',
      },
      {
        text: 'nationalities.ec',
        value: 'ec',
      },
      {
        text: 'nationalities.ee',
        value: 'ee',
      },
      {
        text: 'nationalities.eg',
        value: 'eg',
      },
      {
        text: 'nationalities.eh',
        value: 'eh',
      },
      {
        text: 'nationalities.er',
        value: 'er',
      },
      {
        text: 'nationalities.es',
        value: 'es',
      },
      {
        text: 'nationalities.et',
        value: 'et',
      },
      {
        text: 'nationalities.fi',
        value: 'fi',
      },
      {
        text: 'nationalities.fj',
        value: 'fj',
      },
      {
        text: 'nationalities.fk',
        value: 'fk',
      },
      {
        text: 'nationalities.fm',
        value: 'fm',
      },
      {
        text: 'nationalities.fo',
        value: 'fo',
      },
      {
        text: 'nationalities.fr',
        value: 'fr',
      },
      {
        text: 'nationalities.ga',
        value: 'ga',
      },
      {
        text: 'nationalities.gb',
        value: 'gb',
      },
      {
        text: 'nationalities.gd',
        value: 'gd',
      },
      {
        text: 'nationalities.ge',
        value: 'ge',
      },
      {
        text: 'nationalities.gf',
        value: 'gf',
      },
      {
        text: 'nationalities.gg',
        value: 'gg',
      },
      {
        text: 'nationalities.gh',
        value: 'gh',
      },
      {
        text: 'nationalities.gi',
        value: 'gi',
      },
      {
        text: 'nationalities.gl',
        value: 'gl',
      },
      {
        text: 'nationalities.gm',
        value: 'gm',
      },
      {
        text: 'nationalities.gn',
        value: 'gn',
      },
      {
        text: 'nationalities.gp',
        value: 'gp',
      },
      {
        text: 'nationalities.gq',
        value: 'gq',
      },
      {
        text: 'nationalities.gr',
        value: 'gr',
      },
      {
        text: 'nationalities.gs',
        value: 'gs',
      },
      {
        text: 'nationalities.gt',
        value: 'gt',
      },
      {
        text: 'nationalities.gu',
        value: 'gu',
      },
      {
        text: 'nationalities.gw',
        value: 'gw',
      },
      {
        text: 'nationalities.gy',
        value: 'gy',
      },
      {
        text: 'nationalities.hk',
        value: 'hk',
      },
      {
        text: 'nationalities.hm',
        value: 'hm',
      },
      {
        text: 'nationalities.hn',
        value: 'hn',
      },
      {
        text: 'nationalities.hr',
        value: 'hr',
      },
      {
        text: 'nationalities.ht',
        value: 'ht',
      },
      {
        text: 'nationalities.hu',
        value: 'hu',
      },
      {
        text: 'nationalities.id',
        value: 'id',
      },
      {
        text: 'nationalities.ie',
        value: 'ie',
      },
      {
        text: 'nationalities.il',
        value: 'il',
      },
      {
        text: 'nationalities.im',
        value: 'im',
      },
      {
        text: 'nationalities.in',
        value: 'in',
      },
      {
        text: 'nationalities.io',
        value: 'io',
      },
      {
        text: 'nationalities.iq',
        value: 'iq',
      },
      {
        text: 'nationalities.ir',
        value: 'ir',
      },
      {
        text: 'nationalities.is',
        value: 'is',
      },
      {
        text: 'nationalities.it',
        value: 'it',
      },
      {
        text: 'nationalities.je',
        value: 'je',
      },
      {
        text: 'nationalities.jm',
        value: 'jm',
      },
      {
        text: 'nationalities.jo',
        value: 'jo',
      },
      {
        text: 'nationalities.jp',
        value: 'jp',
      },
      {
        text: 'nationalities.ke',
        value: 'ke',
      },
      {
        text: 'nationalities.kg',
        value: 'kg',
      },
      {
        text: 'nationalities.kh',
        value: 'kh',
      },
      {
        text: 'nationalities.ki',
        value: 'ki',
      },
      {
        text: 'nationalities.km',
        value: 'km',
      },
      {
        text: 'nationalities.kn',
        value: 'kn',
      },
      {
        text: 'nationalities.kp',
        value: 'kp',
      },
      {
        text: 'nationalities.kr',
        value: 'kr',
      },
      {
        text: 'nationalities.kw',
        value: 'kw',
      },
      {
        text: 'nationalities.ky',
        value: 'ky',
      },
      {
        text: 'nationalities.kz',
        value: 'kz',
      },
      {
        text: 'nationalities.la',
        value: 'la',
      },
      {
        text: 'nationalities.lb',
        value: 'lb',
      },
      {
        text: 'nationalities.lc',
        value: 'lc',
      },
      {
        text: 'nationalities.li',
        value: 'li',
      },
      {
        text: 'nationalities.lk',
        value: 'lk',
      },
      {
        text: 'nationalities.lr',
        value: 'lr',
      },
      {
        text: 'nationalities.ls',
        value: 'ls',
      },
      {
        text: 'nationalities.lt',
        value: 'lt',
      },
      {
        text: 'nationalities.lu',
        value: 'lu',
      },
      {
        text: 'nationalities.lv',
        value: 'lv',
      },
      {
        text: 'nationalities.ly',
        value: 'ly',
      },
      {
        text: 'nationalities.ma',
        value: 'ma',
      },
      {
        text: 'nationalities.mc',
        value: 'mc',
      },
      {
        text: 'nationalities.md',
        value: 'md',
      },
      {
        text: 'nationalities.me',
        value: 'me',
      },
      {
        text: 'nationalities.mf',
        value: 'mf',
      },
      {
        text: 'nationalities.mg',
        value: 'mg',
      },
      {
        text: 'nationalities.mh',
        value: 'mh',
      },
      {
        text: 'nationalities.mk',
        value: 'mk',
      },
      {
        text: 'nationalities.ml',
        value: 'ml',
      },
      {
        text: 'nationalities.mm',
        value: 'mm',
      },
      {
        text: 'nationalities.mn',
        value: 'mn',
      },
      {
        text: 'nationalities.mo',
        value: 'mo',
      },
      {
        text: 'nationalities.mp',
        value: 'mp',
      },
      {
        text: 'nationalities.mq',
        value: 'mq',
      },
      {
        text: 'nationalities.mr',
        value: 'mr',
      },
      {
        text: 'nationalities.ms',
        value: 'ms',
      },
      {
        text: 'nationalities.mt',
        value: 'mt',
      },
      {
        text: 'nationalities.mu',
        value: 'mu',
      },
      {
        text: 'nationalities.mv',
        value: 'mv',
      },
      {
        text: 'nationalities.mw',
        value: 'mw',
      },
      {
        text: 'nationalities.mx',
        value: 'mx',
      },
      {
        text: 'nationalities.my',
        value: 'my',
      },
      {
        text: 'nationalities.mz',
        value: 'mz',
      },
      {
        text: 'nationalities.na',
        value: 'na',
      },
      {
        text: 'nationalities.nc',
        value: 'nc',
      },
      {
        text: 'nationalities.ne',
        value: 'ne',
      },
      {
        text: 'nationalities.nf',
        value: 'nf',
      },
      {
        text: 'nationalities.ng',
        value: 'ng',
      },
      {
        text: 'nationalities.ni',
        value: 'ni',
      },
      {
        text: 'nationalities.nl',
        value: 'nl',
      },
      {
        text: 'nationalities.no',
        value: 'no',
      },
      {
        text: 'nationalities.np',
        value: 'np',
      },
      {
        text: 'nationalities.nr',
        value: 'nr',
      },
      {
        text: 'nationalities.nu',
        value: 'nu',
      },
      {
        text: 'nationalities.nz',
        value: 'nz',
      },
      {
        text: 'nationalities.om',
        value: 'om',
      },
      {
        text: 'nationalities.pa',
        value: 'pa',
      },
      {
        text: 'nationalities.pe',
        value: 'pe',
      },
      {
        text: 'nationalities.pf',
        value: 'pf',
      },
      {
        text: 'nationalities.pg',
        value: 'pg',
      },
      {
        text: 'nationalities.ph',
        value: 'ph',
      },
      {
        text: 'nationalities.pk',
        value: 'pk',
      },
      {
        text: 'nationalities.pl',
        value: 'pl',
      },
      {
        text: 'nationalities.pm',
        value: 'pm',
      },
      {
        text: 'nationalities.pn',
        value: 'pn',
      },
      {
        text: 'nationalities.pr',
        value: 'pr',
      },
      {
        text: 'nationalities.ps',
        value: 'ps',
      },
      {
        text: 'nationalities.pt',
        value: 'pt',
      },
      {
        text: 'nationalities.pw',
        value: 'pw',
      },
      {
        text: 'nationalities.py',
        value: 'py',
      },
      {
        text: 'nationalities.qa',
        value: 'qa',
      },
      {
        text: 'nationalities.re',
        value: 're',
      },
      {
        text: 'nationalities.ro',
        value: 'ro',
      },
      {
        text: 'nationalities.rs',
        value: 'rs',
      },
      {
        text: 'nationalities.ru',
        value: 'ru',
      },
      {
        text: 'nationalities.rw',
        value: 'rw',
      },
      {
        text: 'nationalities.sa',
        value: 'sa',
      },
      {
        text: 'nationalities.sb',
        value: 'sb',
      },
      {
        text: 'nationalities.sc',
        value: 'sc',
      },
      {
        text: 'nationalities.sd',
        value: 'sd',
      },
      {
        text: 'nationalities.se',
        value: 'se',
      },
      {
        text: 'nationalities.sg',
        value: 'sg',
      },
      {
        text: 'nationalities.sh',
        value: 'sh',
      },
      {
        text: 'nationalities.si',
        value: 'si',
      },
      {
        text: 'nationalities.sj',
        value: 'sj',
      },
      {
        text: 'nationalities.sk',
        value: 'sk',
      },
      {
        text: 'nationalities.sl',
        value: 'sl',
      },
      {
        text: 'nationalities.sm',
        value: 'sm',
      },
      {
        text: 'nationalities.sn',
        value: 'sn',
      },
      {
        text: 'nationalities.so',
        value: 'so',
      },
      {
        text: 'nationalities.sr',
        value: 'sr',
      },
      {
        text: 'nationalities.ss',
        value: 'ss',
      },
      {
        text: 'nationalities.st',
        value: 'st',
      },
      {
        text: 'nationalities.sv',
        value: 'sv',
      },
      {
        text: 'nationalities.sx',
        value: 'sx',
      },
      {
        text: 'nationalities.sy',
        value: 'sy',
      },
      {
        text: 'nationalities.sz',
        value: 'sz',
      },
      {
        text: 'nationalities.tc',
        value: 'tc',
      },
      {
        text: 'nationalities.td',
        value: 'td',
      },
      {
        text: 'nationalities.tf',
        value: 'tf',
      },
      {
        text: 'nationalities.tg',
        value: 'tg',
      },
      {
        text: 'nationalities.th',
        value: 'th',
      },
      {
        text: 'nationalities.tj',
        value: 'tj',
      },
      {
        text: 'nationalities.tk',
        value: 'tk',
      },
      {
        text: 'nationalities.tl',
        value: 'tl',
      },
      {
        text: 'nationalities.tm',
        value: 'tm',
      },
      {
        text: 'nationalities.tn',
        value: 'tn',
      },
      {
        text: 'nationalities.to',
        value: 'to',
      },
      {
        text: 'nationalities.tr',
        value: 'tr',
      },
      {
        text: 'nationalities.tt',
        value: 'tt',
      },
      {
        text: 'nationalities.tv',
        value: 'tv',
      },
      {
        text: 'nationalities.tw',
        value: 'tw',
      },
      {
        text: 'nationalities.tz',
        value: 'tz',
      },
      {
        text: 'nationalities.ua',
        value: 'ua',
      },
      {
        text: 'nationalities.ug',
        value: 'ug',
      },
      {
        text: 'nationalities.um',
        value: 'um',
      },
      {
        text: 'nationalities.us',
        value: 'us',
      },
      {
        text: 'nationalities.uy',
        value: 'uy',
      },
      {
        text: 'nationalities.uz',
        value: 'uz',
      },
      {
        text: 'nationalities.va',
        value: 'va',
      },
      {
        text: 'nationalities.vc',
        value: 'vc',
      },
      {
        text: 'nationalities.ve',
        value: 've',
      },
      {
        text: 'nationalities.vg',
        value: 'vg',
      },
      {
        text: 'nationalities.vi',
        value: 'vi',
      },
      {
        text: 'nationalities.vn',
        value: 'vn',
      },
      {
        text: 'nationalities.vu',
        value: 'vu',
      },
      {
        text: 'nationalities.wf',
        value: 'wf',
      },
      {
        text: 'nationalities.ws',
        value: 'ws',
      },
      {
        text: 'nationalities.xk',
        value: 'xk',
      },
      {
        text: 'nationalities.ye',
        value: 'ye',
      },
      {
        text: 'nationalities.yt',
        value: 'yt',
      },
      {
        text: 'nationalities.za',
        value: 'za',
      },
      {
        text: 'nationalities.zm',
        value: 'zm',
      },
      {
        text: 'nationalities.zw',
        value: 'zw',
      },
      {
        text: 'nationalities.other',
        value: 'other',
      },
    ],
  },
  healthInformation: {
    label: 'contact.contact_individual.profile.health_information.label',
  },
};
